import React, {useCallback, useEffect, useRef, useState} from "react";
// Removed RiveDemo import as it wasn't used in the original snippet provided
// import {RiveDemo} from "../../utils/animateExample";
import api from '../../api';
import {TextAnimator} from "../../utils/text-animator";
import SliderWithImagesPopup from '../SliderWithImagesPopup';
import AdvCampaignPopup from '../popups/AdvCampaignPopup';
import './IndexContentEmpty'; // Assuming this CSS import is correct
import SendOkPopup from "../popups/SendOkPopup";
// Import useNavigate instead of Link for programmatic navigation
import {Link, useNavigate} from "react-router-dom";


const LawContentEmpty = () => {
    const [animator, setAnimator] = useState(null);
    const [hoverDescription, setHoverDescription] = useState(false);
    const [listTitle, setListTitle] = useState('');
    const [listDescription, setListDescription] = useState('');
    const [mediaData, setMediaData] = useState([]);  // State for media_items
    const [isAdvCampaignPopupVisible, setIsAdvCampaignPopupVisible] = useState(false); // State for original popup
    const titleRef = useRef(null);
    const [showSendOkPopup, setShowSendOkPopup] = useState(false);
    const navigate = useNavigate(); // <<--- MODIFICATION: Add useNavigate hook

    useEffect(() => {
        api.get('/advertising-sections/', {params: {template_number: 'law-firm'}})
            .then(response => {
                // Add checks for robustness
                if (response.data && response.data.length > 0) {
                    const section = response.data[0];
                    // Use optional chaining and provide default empty string
                    const baseUrl = process.env.REACT_APP_BASE_URL?.replace(/\/+$/, '') || '';
                    const processedMediaItems = (section.media_items || []).map(item => {
                        const url = item.url?.replace(/^\/+/, '') || '';
                        return {
                            type: item.type,
                            src: `${baseUrl}/${url}`
                        };
                    });

                    setListTitle(section.title || 'Become a Partner'); // Default title
                    setListDescription(section.description || 'Register your law firm to connect with clients.'); // Default description
                    setMediaData(processedMediaItems);
                } else {
                    console.warn('No advertising section found for template_number: law-firm');
                    // Set default content if API returns no data
                    setListTitle('Become a Partner');
                    setListDescription('Register your law firm to connect with clients.');
                    setMediaData([]);
                }
            })
            .catch(error => {
                console.error('Error fetching advertising section (law-firm):', error);
                // Set error content
                setListTitle('Error Loading');
                setListDescription('Could not load content. Please try again later.');
                setMediaData([]);
            });
    }, []); // Empty dependency array ensures this runs only once on mount


    // --- Animation Logic (Original - Kept as is) ---
    useEffect(() => {
        let instance = null;
        if (titleRef.current) {
            instance = new TextAnimator(titleRef.current);
            setAnimator(instance);
        }
        // Cleanup function for animator if needed
        return () => {
            // Assuming TextAnimator might have a destroy or cleanup method
            // if (instance) instance.destroy();
        };
    }, [listTitle]); // Recreate animator if listTitle changes

    const animateText = useCallback(() => {
        if (animator) {
            animator.reset();
            animator.animate();
        }
    }, [animator]);

    const handleIntersection = useCallback((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateText();
            }
        });
    }, [animateText]);

    useEffect(() => {
        let observer;
        const currentRef = titleRef.current; // Capture ref value
        if (currentRef) {
            observer = new IntersectionObserver(handleIntersection, {
                threshold: 0.1
            });
            observer.observe(currentRef);
        }
        return () => {
            // Use captured value in cleanup
            if (observer && currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [handleIntersection]); // Dependency on the callback

    const handlerHover = useCallback(() => {
        setHoverDescription(true); // Set state regardless of previous value on hover
        animateText(); // Animate on hover
    }, [animateText]); // Dependency only on animateText


    // --- Popup Logic (Original - Kept as is, but button action changed) ---
    const showAdvCampaignPopup = (e) => {
        e.preventDefault();
        setIsAdvCampaignPopupVisible(true);
    };

    const handleShowSendOkPopup = useCallback(() => {
        setShowSendOkPopup(true);
        setIsAdvCampaignPopupVisible(false); // Close AdvCampaignPopup when showing OK Popup
    }, []);

    const closeAdvCampaignPopup = useCallback(() => {
        setIsAdvCampaignPopupVisible(false);
    }, []);

    const handlerCloseOk = useCallback(() => {
        setShowSendOkPopup(false);
    }, []);

    // --- MODIFICATION: Click Handler for the new button action ---
    const handleCreateLawFirmClick = (e) => {
        e.preventDefault(); // Prevent default button behavior
        // Navigate to the sign-up page, passing 'lawyer' as the initial type
        navigate('/sign-up', {state: {initialRegistrationType: 'lawyer'}});
    };
    // --- End Modification ---

    return (
        <div className='about'>
            <div className='content'>
                <div className='about__compaign'>
                    <div className='container'>
                        <div className='text'>
                            {/* Attach ref for animator */}
                            <h2>{listTitle}</h2>
                            <p>{listDescription}</p>
                            <div className='button-container'>
                                <a href='' className='button button-black' onClick={showAdvCampaignPopup}>Start
                                    Campaign</a>
                                <a href='' className='button button-border add-info-butto'
                                   onClick={handleCreateLawFirmClick}>Attorney Signup</a>
                            </div>

                        </div>
                        <div className='container'>
                            <div className='about__offices'>
                                <SliderWithImagesPopup mediaData={mediaData}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Original Popup rendering logic */}
            {isAdvCampaignPopupVisible && (
                <AdvCampaignPopup
                    show={isAdvCampaignPopupVisible}
                    closeAdvCampaignPopup={closeAdvCampaignPopup}
                    showSendOkPopup={handleShowSendOkPopup}

                />
            )}
            {showSendOkPopup && <SendOkPopup closePopup={handlerCloseOk}/>}
        </div>
    );
};


export default LawContentEmpty;